










import Vue from 'vue'
import Component from 'vue-class-component'

import headerComponent from '@/components/header.vue'
import footerComponent from '@/components/footer.vue'

@Component({
  components: { headerComponent, footerComponent }
})
export default class Home extends Vue {
}

